import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { subscription } from '../services/api';

const SuccessPage = () => {
  const location = useLocation();
  const isSuccess = location.pathname === '/success';
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        // Add a small delay to allow webhook processing
        await new Promise(resolve => setTimeout(resolve, 2000));
        const response = await subscription.getCurrentPlan();
        setSubscriptionDetails(response.data);
      } catch (error) {
        console.error('Error fetching subscription details:', error);
      }
    };

    if (isSuccess) {
      fetchSubscriptionDetails();
    }
  }, [isSuccess]);

  // Add a loading state
  if (isSuccess && !subscriptionDetails) {
    return <div>Loading subscription details...</div>;
  }


  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-6">
        {isSuccess ? (
          <>
            <h1 className="text-2xl font-bold mb-4">Payment Successful!</h1>
            <p className="text-gray-600 mb-6">Thank you for your subscription.</p>
            <hr className="border-t border-gray-200 my-6" />
            {subscriptionDetails ? (
              <>
                <div className="flex justify-between">
                  <div>
                    <p className="text-gray-600 mb-1">Subscription Plan</p>
                    <p className="text-lg font-bold">{subscriptionDetails.name}</p>
                  </div>
                </div>
                <hr className="border-t border-gray-200 my-6" />
              </>
            ) : (
              <p className="text-gray-600 mb-6">Loading subscription details...</p>
            )}
            <div className="text-right">
              <Link
                to="/library"
                className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
              >
                Return to Game Library
              </Link>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-4">Payment Cancelled</h1>
            <p className="text-gray-600 mb-6">Your subscription payment was cancelled.</p>
            <div className="text-right">
              <Link
                to="/subscription"
                className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
              >
                Return to Subscription Page
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SuccessPage;